import { createSelector } from 'reselect';

import type { PortalUser } from './types';

const selectUserId = (state: AppState) => state.account?.AccountId;
const selectAppAccessLevel = (state: AppState) => state.currentApp?.AppAccessLevel;
const selectPermissions = (state: AppState) => state.permissions;

export const selectPortalUser = createSelector(
  [selectUserId, selectAppAccessLevel, selectPermissions],
  (userId, role, permissions): PortalUser => ({
    userId,
    role,
    permissions: permissions ?? [],
  })
);
